import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=663dcd2b&scoped=true&"
import script from "./DashboardPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=663dcd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663dcd2b",
  null
  
)

export default component.exports